import React, { useState } from 'react';
import { Sidebar } from '../components/Sidebar';
import { TopBar } from '../components/TopBar';
import { FloatingAssistant } from '../components/FloatingAssistant';

interface MainLayoutProps {
  children: React.ReactNode;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className="h-screen w-screen max-w-full bg-brand-bg flex flex-col overflow-hidden">
      {/* Global top header bar */}
      <TopBar onMenuClick={() => setMobileNavOpen(true)} />

      {/* Main area: sidebar on the left, content on the right */}
      <div className="flex flex-1 min-h-0 min-w-0">
        <Sidebar mobileOpen={mobileNavOpen} onCloseMobile={() => setMobileNavOpen(false)} />

        {/* Allow page scroll; bottom safe-area for notched devices */}
        <main
          className="flex-1 min-h-0 min-w-0 overflow-auto bg-brand-bg"
          style={{ paddingBottom: 'env(safe-area-inset-bottom, 0)' }}
        >
          {children}
        </main>
      </div>

      {/* Aquamaris Copilot — floating AI assistant available on every authenticated page */}
      <FloatingAssistant />
    </div>
  );
};
